import { useState, useEffect } from "react";
import axios from "axios";

const APIBaseUrl = "https://api.compteur.rip/";

export async function makeFetch(path, setData) {
  const result = await axios.get(`${APIBaseUrl}${path}`);
  setData(result.data);
}

export function useFetch(path) {
  const [data, setData] = useState(null);

  useEffect(() => {
    makeFetch(path, setData);
  }, [path]);

  return data;
}
